import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/user/female.png'
import _imports_1 from '../../assets/images/user/male.png'
import _imports_2 from '../../assets/images/user/on-job.png'
import _imports_3 from '../../assets/images/user/leave-job.png'


const _withScopeId = n => (_pushScopeId("data-v-23959a78"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "user_info_main"
}
const _hoisted_2 = { class: "user_info" }
const _hoisted_3 = { class: "user_info-view" }
const _hoisted_4 = { class: "user_info-view-header" }
const _hoisted_5 = { class: "user_info-view-header-text" }
const _hoisted_6 = { class: "user_info-view-header-info" }
const _hoisted_7 = { class: "user_info-view-header-name" }
const _hoisted_8 = {
  key: 0,
  class: "user_info-view-header-male",
  src: _imports_0,
  alt: ""
}
const _hoisted_9 = {
  key: 1,
  class: "user_info-view-header-male",
  src: _imports_1,
  alt: ""
}
const _hoisted_10 = {
  key: 2,
  class: "user_info-view-header-job",
  src: _imports_2,
  alt: ""
}
const _hoisted_11 = {
  key: 3,
  class: "user_info-view-header-job",
  src: _imports_3,
  alt: ""
}
const _hoisted_12 = { class: "user_info-view-header-department" }
const _hoisted_13 = { class: "user_info-view-header-department" }
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 1,
  class: "user_info-view-header-firstname"
}
const _hoisted_16 = { class: "user_info_detail" }
const _hoisted_17 = { class: "user_info_detail-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "user_info_detail-item-label" }, "专业：", -1))
const _hoisted_19 = { class: "user_info_detail-item-text" }
const _hoisted_20 = { class: "user_info_detail-item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "user_info_detail-item-label" }, "手机：", -1))
const _hoisted_22 = { class: "user_info_detail-item-text" }
const _hoisted_23 = { class: "user_info_detail-item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "user_info_detail-item-label" }, "邮箱：", -1))
const _hoisted_25 = { class: "user_info_detail-item-text" }
const _hoisted_26 = {
  key: 0,
  class: "user_info-tel"
}
const _hoisted_27 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.storeInfo.data)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.storeInfo.data.name), 1),
                  (_ctx.storeInfo.data.gender == 2)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                    : (_openBlock(), _createElementBlock("img", _hoisted_9)),
                  (_ctx.storeInfo.data.job_state == 1)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                    : (_openBlock(), _createElementBlock("img", _hoisted_11))
                ]),
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.storeInfo.data.department_name), 1),
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.storeInfo.data.duty_name), 1)
              ]),
              (_ctx.storeInfo.data.head_pic)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "user_info-view-header-head",
                    src: _ctx.storeInfo.data.head_pic,
                    alt: ""
                  }, null, 8, _hoisted_14))
                : (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.firstName), 1))
            ]),
            _createElementVNode("ul", _hoisted_16, [
              _createElementVNode("li", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.storeInfo.data.subgroup_names || "-"), 1)
              ]),
              _createElementVNode("li", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.storeInfo.data.mobile || "-"), 1)
              ]),
              _createElementVNode("li", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.storeInfo.data.email || "-"), 1)
              ])
            ])
          ])
        ]),
        (_ctx.storeInfo.data.mobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("a", {
                href: 'tel:' + _ctx.storeInfo.data.mobile
              }, "拨打电话", 8, _hoisted_27)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}